var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "3" } },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-container",
                    { staticClass: "pt-5" },
                    [
                      _c("v-autocomplete", {
                        staticClass: "pa-0 ma-0",
                        attrs: {
                          dense: "",
                          label: "Report",
                          items: ["revenues", "collections"],
                          "hide-details": ""
                        },
                        model: {
                          value: _vm.reportType,
                          callback: function($$v) {
                            _vm.reportType = $$v
                          },
                          expression: "reportType"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("v-col", { attrs: { cols: "3" } }, [
            _c(
              "div",
              {
                staticStyle: {
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  "align-items": "center"
                }
              },
              [
                _c(
                  "v-btn",
                  {
                    attrs: {
                      color: "green",
                      dense: "",
                      dark: "",
                      loading: _vm.exportingExcel
                    },
                    on: { click: _vm.exportCollectionExcel }
                  },
                  [_vm._v("Export")]
                )
              ],
              1
            )
          ]),
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "v-card",
                { staticClass: "mb-1" },
                [
                  _c(
                    "v-container",
                    [
                      _c(
                        "v-overlay",
                        {
                          attrs: {
                            value: _vm.revenueSourceSaleGetting,
                            absolute: ""
                          }
                        },
                        [
                          _c("v-progress-circular", {
                            attrs: {
                              size: "60",
                              color: "white",
                              indeterminate: ""
                            }
                          })
                        ],
                        1
                      ),
                      _c("revenue-source-sales-chart", {
                        attrs: {
                          "sales-data": _vm.revenueSourceSaleList,
                          interval: _vm.interval,
                          date: this.date,
                          "report-type": _vm.reportType
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "3" } },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-container",
                    [
                      _c("v-simple-table", {
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function() {
                              return [
                                _c("thead", [
                                  _c("tr", [
                                    _c("th", [_vm._v("Revenue Source")]),
                                    _c("th", [_vm._v("Amount Today")])
                                  ])
                                ]),
                                _c(
                                  "tbody",
                                  [
                                    _vm._l(_vm.revenueSourceSaleToday, function(
                                      item,
                                      index
                                    ) {
                                      return _c("tr", { key: index }, [
                                        _c("th", [_vm._v(_vm._s(item.label))]),
                                        _c(
                                          "td",
                                          { staticClass: "text-right" },
                                          [
                                            _vm._v(
                                              _vm._s(item.amount.phpFormat())
                                            )
                                          ]
                                        )
                                      ])
                                    }),
                                    _vm.revenueSourceSaleGetting
                                      ? _c("tr", [
                                          _c(
                                            "td",
                                            {
                                              staticClass: "text-center",
                                              attrs: { colspan: "2" }
                                            },
                                            [
                                              _c("v-progress-circular", {
                                                attrs: {
                                                  size: "20",
                                                  color: "primary",
                                                  indeterminate: ""
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ])
                                      : _vm._e()
                                  ],
                                  2
                                )
                              ]
                            },
                            proxy: true
                          }
                        ])
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "3" } },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "v-card",
                        [
                          _c("v-slider", {
                            attrs: {
                              "tick-labels": _vm.sliderLabels,
                              step: "1",
                              max: 4,
                              ticks: "",
                              "tick-size": "0",
                              "thumb-label": ""
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "thumb-label",
                                fn: function({ value }) {
                                  return [
                                    _c("small", [
                                      _vm._v(_vm._s(_vm.sliderLabels[value]))
                                    ])
                                  ]
                                }
                              }
                            ]),
                            model: {
                              value: _vm.intervalIndex,
                              callback: function($$v) {
                                _vm.intervalIndex = $$v
                              },
                              expression: "intervalIndex"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "v-card",
                        [
                          _c(
                            "v-container",
                            [
                              _c("v-text-field", {
                                attrs: {
                                  "hide-details": "",
                                  label: "Date",
                                  type: "date"
                                },
                                model: {
                                  value: _vm.date,
                                  callback: function($$v) {
                                    _vm.date = $$v
                                  },
                                  expression: "date"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }